import { Injectable } from '@angular/core'

import { AddInquiryDialogParams } from '@tv3/interfaces/dialogs/add-inquiry-dialog-params'
import { AddInquiryDialogComponent } from '@tv3/containers/inquiries/dialogs/shared/add-inquiry/add-inquiry-dialog.component'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable()
export class AddInquiryDialogService {
  constructor(private sidePanel: DialogService) {}

  open(params?: AddInquiryDialogParams) {
    return this.sidePanel.openDrawer(AddInquiryDialogComponent, {
      data: params || {},
      panelClass: ['drawer-full-60'],
    })
  }
}
